
export const OEShowInitiallyFlags = {
    hide:                                   0,
    show:                                   1,
    onlyAtStartUp:                          2,
    atTargetChange:                         4,

    resolve(flags)    {
        if(typeof(flags) === 'boolean')  return {show: flags, onlyAtStartUp: false, atTargetChange: false};
        if(typeof(flags) !== 'number')  return {show: false, onlyAtStartUp: false, atTargetChange: false};
        return {show: !!(flags & OEShowInitiallyFlags.show), onlyAtStartUp: !!(flags & OEShowInitiallyFlags.onlyAtStartUp), atTargetChange: !!(flags & OEShowInitiallyFlags.atTargetChange)};
    }
};

export const OEViewType = {
    start:                                  'start',
    welcome:                                'welcome',
    info:                                   'info',
    help:                                   'help',
    manual:                                 'manual',
    screenshot:                             'screenshot',
    text:                                   'text',
    startSelection:                         'startSelection',
    freePremium:                            'freePremium',
    infoMessage:                            'infoMessage',
    customExt:                              'customExt',
    secondarySettings:                      'secondarySettings',
    offlineManager:                         'offlineManager',

    getRef: (type, appComponent) => {
        return appComponent ? appComponent.uiLayer[type + 'View'] : undefined;
    }
};

export const OEControlState = {
    normal:                                 0,
    highlighted:                            1,
    disabled:                               2,
    selected:                               4,
    focused:                                8,
    active:                                 16,
    MAX:                                    31,
    COUNT:                                  32
};

export const OEContextMenuContentType = {
    none:                                   'none',
    infoBox:                                'infoBox',
    array:                                  ['none', 'infoBox']
};

export const OEStartViewTypes = {
    amboss:                                 'amboss',
    anatomy:                                'anatomy',
    bayer:                                  'bayer',
    bbraun:                                 'bbraun',
    cell:                                   'cell',
    demo:                                   'demo',
    ear:                                    'ear',
    equineHoof:                             'equineHoof',
    implantcast:                            'implantcast',
    ionto:                                  'ionto',
    ortho:                                  'ortho',
    mediCADemy:                             'mediCADemy',
    school:                                 'school',
    science:                                'science',
    skin:                                   'skin',
    sport:                                  'sport',
    std:                                    'std',
    surgery:                                'surgery',
    test:                                   'test',
    thieme:                                 'thieme',
    toxnetz:                                'toxnetz',
    xRay:                                   'xRay',
    zeissOpti:                              'zeissOpti'
};

export const OEFreePremiumViewTypes = {
    none:                                   'none',
    std:                                    'std',
    test:                                   'test'
};

export const OECutControllerStyle = {
    std:                                    'std',
    minimal:                                'minimal'
};

export const OEMediaViewerContentType = {
    dummy:                                  'dummy',
    image:                                  'image',
    video:                                  'video',
    web:                                    'web',
    pdf:                                    'pdf'
};

// module independent ui level representation  
export const UILevel = {
    std:                                    'std',
    simple:                                 'simple',
    advanced:                               'advanced',

    levelFromModuleValue: function(value) {
        return value == 2 ? UILevel.advanced : (value == 1 ? UILevel.simple : UILevel.std);
    },
    moduleValueFromLevel: function(level)   {
        return level === UILevel.advanced ? 2 : (level === UILevel.simple ? 1 : 0);
    }
};

//
export const OEMainMenuControlBarEntryTypes = {
    mainMenuControlButton:                  'main_menu_control_button',
    logo:                                   'logo',
    targetMenu:                             'target_menu'
};